import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AiPanelService {
  private readonly _visible = signal(false);
  private readonly _isEnabled = signal(false);

  readonly visible = this._visible.asReadonly();
  readonly isEnabled = this._isEnabled.asReadonly();

  toggle(): void {
    this._visible.update((v) => !v);
  }

  set(visible: boolean): void {
    this._visible.set(visible);
  }

  setIsEnabled(enabled: boolean): void {
    this._isEnabled.set(enabled);
    if (!enabled) {
      this._visible.set(false);
    }
  }
}
